$(function () {

	//お手紙スライドショー
	var mySwiper = new Swiper('.customer_swiper', {
		loop: true,
		speed: 1500,
		effect: 'fade',
		allowTouchMove: false,
		// slidesPerView: 1,
		autoplay: {
			delay: 4000,
		},
	});

});